import React from "react";
import styled from "styled-components";

import { ModalService } from "../service/modal-service";
import { Col, Text, Button, Row } from "../comps";
import { Theme } from "../theme/theme-provider";

import { faCheck, faTimes } from "@fortawesome/free-solid-svg-icons";

const Wrapper = styled(Col)`
  width: 100%;
  height: 100%;
  background: ${({ theme }) => theme.color.BLACK_0};
  overflow: hidden;
  align-items: center;
`;

const Head = styled(Col)`
  width: 90%;
  margin-top: 5px;
  padding: 10px;
  justify-content: center;
  align-items: center;
  border-bottom: 1px solid ${({ theme }) => theme.color.GRAY_2};
`;

const ButtonWrapper = styled(Row)`
  margin-top: 18px;
  justify-content: space-between;
`;

export default ({ title, handleSubmit, yes, no, shouldNotClose }) => {
  const handleAccept = () => {
    handleSubmit();
    if (!shouldNotClose) ModalService.closeModal();
  };

  const handleReject = () => {
    if (!shouldNotClose) ModalService.closeModal();
  };

  return (
    <Wrapper>
      <Head>
        <Text
          fontSize="16px"
          width="90%"
          color={Theme.textColor.light}
          textAlign="left"
        >
          {title}
        </Text>
      </Head>
      <ButtonWrapper>
        {no && (
          <Button
            buttonTextColor={Theme.textColor.light}
            borderRadius="50"
            buttonBackground={Theme.color.RED_5}
            buttonName={no}
            buttonIcon={faTimes}
            buttonFontSize="14px"
            size="small"
            onClick={handleReject}
          />
        )}
        <Button
          marginLeft="20px"
          buttonTextColor={Theme.textColor.light}
          borderRadius="50"
          buttonBackground={Theme.color.BLUE_4}
          buttonName={yes || "yes"}
          buttonIcon={faCheck}
          buttonFontSize="14px"
          size="small"
          onClick={handleAccept}
        />
      </ButtonWrapper>
    </Wrapper>
  );
};
